
/*
* 轮播图
*/

<template>
  <div class="hbn-container" id="userInfo">
    <div class="search-form">
      <!-- <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="top"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="公告标题">
                  <el-input
                    id="queryModelName"
                    v-model="PageQuery.queryModel.title"
                    placeholder="公告标题"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item style="padding-top: 28px">
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row> -->
    </div>

    <div class="hbn-table-screen">
      <!-- <div class="operation">
        <el-button type="primary" size="mini" @click="updateImage(0)"
          >上传</el-button
        >
      </div> -->
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          :icon="Search"
          @click="add"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <!-- <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column> -->
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template v-for="(item, key) in SlideshowList" :key="key">
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow && item.prop != 'url'"
                show-overflow-tooltip
                :sortable="item.order"
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-else-if="item.isShow && item.prop == 'url'"
                show-overflow-tooltip
                :sortable="item.order"
                :class-name="JSON.stringify(item)"
              >
                <template #default="{ row }">
                  <img
                    width="100"
                    height="50"
                    :src="row.resourceRul"
                    title=""
                  />
                </template>
              </vxe-table-column>
            </template>

            <vxe-table-column
              width="180"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ rowIndex }">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Detail')"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Modify')"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Delete')"
                  >删除</el-button
                >
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
    <excel
      ref="industrialUnitExcel"
      :importurl="importurl"
      fileName="所属行业.xlsx"
      :dialogVisible="UpLoaddialogVisible"
      @close-dialog="closeUpDialog"
      @error="error"
      @success="success"
    ></excel>
    <!-- 图片上传 strat-->
    <el-dialog
      title="上传"
      width="400px"
      v-if="dialogUpdate"
      v-model="dialogUpdate"
      :before-close="() => (dialogUpdate = false)"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-upload
        ref="updateImage"
        drag
        action="#"
        multiple
        :limit="1"
        :auto-upload="false"
        :show-file-list="true"
        :file-list="fileList"
        :accept="acceptName"
        list-type="resource"
        :on-change="changeUploadImg"
        :on-remove="handleRemove"
      >
        <div>23434</div>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <template v-slot:tip>
          <div class="el-upload__tip">
            <span>只能上传jpg/png图片</span>
            <span class="pictureWarn"
              >轮播图片建议大小为宽335像素/高160像素</span
            >
          </div>
        </template>
      </el-upload>
      <template v-slot:footer>
        <div class="priorityNum">
          <span>优先级：</span>
          <el-input-number
            v-model="entityData.number"
            class="mx-4"
            :min="0"
            size="mini"
            controls-position="right"
          />
        </div>
        <span class="dialog-footer">
          <el-button @click="dialogUpdate = false">取 消</el-button>
          <el-button type="primary" @click="updateImage">确定上传</el-button>
        </span></template
      >
    </el-dialog>
    <!-- 图片上传 end-->
    <SlideshowEdit
      ref="SlideshowEdit"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancel"
      @handle-confirm="handleConfirm"
    ></SlideshowEdit>
  </div>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";
import { SlideshowList } from "@/assets/apiData/SlideshowList";
import {
  GetDataSlideshowList,
  DeleteSlideshow,
  ModifySlideshow,
  AddSlideshow,
  SelectSlideshowByNumber,
} from "@api/ApiSlideshow";

// import XEUtils from "xe-utils";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import { post } from "@/util/request";
import { ossUpload, ossPreview } from "@/util/ossClient.js";
import SlideshowEdit from "@comp/Company/SlideshowEdit.vue";
import { dateFormat } from "@/util/utils.js";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      Industry: {
        CodeID: "",
        Name: "",
      },
      SlideshowList: [],
      DataList: [],
      url: "",
      importurl: "/api/IndustrialUnit/ImportExcel?tabname=Industry",
      dialogUpdate: false,
      fileList: [],
      acceptName: ".jpg,.png,.jpeg", //文件格式
      entityData: {
        creatorName: "",
        number: 1,
        compayId: "",
        resourceUrl: "",
      },
    };
  },
  components: {
    excel,
    Search,
    SlideshowEdit,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    error() {},
    success() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
    },
    importExcel() {
      this.UpLoaddialogVisible = true;
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(v.SlideshowList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.SlideshowList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名
        const list = v.DataList;
        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `所属行业`);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleClick(index, type) {
      this.SlideshowEdit(index, type);
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "checkbox":
          cellValue = cellValue == "1" ? "是" : "否";
          break;
        case "status":
          cellValue = cellValue == "1" ? "启用" : "停用";
          break;
      }
      return cellValue;
    },
    SlideshowEdit(index, type) {
      var _this = this;
      let entityData = this.DataList[index];
      if (type == "Delete") {
        DeleteSlideshow(entityData.id).then(function (data) {
          if (data) {
            _this.$message.success("删除成功");
            _this.PageQuery.pageindex = 1;
            _this.GetData();
          }
        });
      } else {
        this.dialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        this.$refs.SlideshowEdit.loadDataById(id, type);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    add() {
      this.SlideshowEdit(-1, "Add");
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    SearchDataInfo() {},
    GetData() {
      const _this = this;
      this.SearchDataInfo();
      try {
        GetDataSlideshowList(JSON.stringify(this.PageQuery)).then(function (
          data
        ) {
          _this.DataList = data.entities;
          _this.total = data.totalCount;
          if (_this.DataList.length > 0) {
            _this.DataList.forEach((item) => {
              item.resourceRul = ossPreview(item.resourceUrl, "1");
            });
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    changeUploadImg(file) {
      let _name = file.name.split(".");
      var filetype = _name[1];
      var lx = "";
      let filetypeList = ["jpg", "png", "jpeg"];
      console.log("filename" + file.name);
      console.log("filetype" + filetype);
      if (!filetypeList.includes(filetype.toLowerCase())) {
        this.$refs.updateImage.handleRemove(file);
        this.$message.error("上传格式错误");
        return false;
      }
    },
    //上传图片
    async updateImage(type) {
      let that = this;
      if (type == 0) {
        that.dialogUpdate = true;
      } else {
        let files = that.$refs.updateImage.uploadFiles;
        if (files.length <= 0) {
          that.$message.warning("请先选择图片文件!");
          return;
        }
        if (this.entityData.number == null) {
          that.$message.warning("请输入优先级!");
          return;
        } else {
          let result = await SelectSlideshowByNumber(this.entityData.number);

          if (result) {
            that.$message.warning(
              `优先级：${this.entityData.number} 已存在，请重新输入！`
            );
            return;
          }
        }
        files = that.$refs.updateImage.uploadFiles.map((el) => {
          return el.raw;
        });
        files.forEach((item) => {
          var formData = new FormData();
          var File = item;
          File.fileName = files
            .map((el) => {
              return el.name;
            })
            .join("|");
          formData.append("File", item);
          let textArray = File.fileName.split(".");
          let extension = "." + textArray[textArray.length - 1]; // 取后缀名
          let fileName = Date.parse(new Date()) + extension;
          let loading = that.GetLoading("上传中...");
          //上传到Oss
          ossUpload(fileName, File, "1")
            .then((result) => {
              let USER_INFO = JSON.parse(localStorage.getItem("USER_INFO"))
              let params = {
                creatorName: USER_INFO.UserName,
                number: that.entityData.number,
                compayId: USER_INFO.CompanyId,
                resourceUrl: fileName, //存Oss管理器上的文件名
              };
              AddSlideshow(params).then(function () {
                that.$message.success("新增成功!");
                that.GetData();
              });
            })
            .then((result) => {
              loading.close();
              that.dialogUpdate = false;
              that.GetData();
            })
            .catch((e) => {
              loading.close();
            });
          /*
          post("/api/app/file/uploadFile", formData, {})
            .then((datas) => {
              //处理成功后插入数据
              if (datas) {
                let USER_INFO = JSON.parse(localStorage.getItem("USER_INFO"))
                let params = {
                  creatorName: USER_INFO.UserName,
                  number: that.entityData.number,
                  compayId: USER_INFO.companyId,
                  resourceUrl:
                    that.VUE_APP_API_URL +
                    "/api/app/file/download?filename=" +
                    File.fileName,
                };
                AddSlideshow(params).then(function () {
                  that.$message.success("新增成功!");
                  that.GetData();
                });
              }
            })
            .then((result) => {
              loading.close();
              that.dialogUpdate = false;
              that.GetData();
            })
            .catch((e) => {
              loading.close();
            });
          */
        });
      }
    },
    GetLoading(text) {
      return this.$loading({
        lock: true,
        text: text,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
  created() {
    this.SlideshowList = SlideshowList;
    this.GetData();
  },
};
</script>
<style lang="scss">
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
.priorityNum {
  text-align: left;
  margin: 10px;
}
.pictureWarn {
  margin-left: 10px;
  color: red;
}
</style>
